module.exports = __webpack_public_path__ + "static/media/clock-circle.5c9f71e4.svg";